<template>
  <div class="compliant-banners" role="region">
    <div class="container banner-container">
      <div class="carousel slide" data-interval="6000" data-ride="carousel" id="compliantBannerCarousel">
        <ol class="carousel-indicators">
          <li class="active" data-slide-to="0" data-target="#compliantBannerCarousel">
            <div class="inner-circle"></div>
          </li>
          <li data-slide-to="1" data-target="#compliantBannerCarousel" class="">
            <div class="inner-circle"></div>
          </li>
          <li data-slide-to="2" data-target="#compliantBannerCarousel" class="">
            <div class="inner-circle"></div>
          </li>
          <li data-slide-to="3" data-target="#compliantBannerCarousel" class="">
            <div class="inner-circle"></div>
          </li>
        </ol>
        <div class="carousel-inner" v-if="images.homeBanners.length > 0">
          <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
            <img :src="banner">
          </div>
        </div>
        <a class="left carousel-control" data-slide="prev" href="#compliantBannerCarousel">
          <img alt="Previous" class="carousel-chevron chevron-left chevron-dark reviews-chevron" src="../../static/images/common-icons/left-arrow-white.png">
        </a>
        <a class="right carousel-control" data-slide="next" href="#compliantBannerCarousel">
          <img alt="Next" class="carousel-chevron chevron-right chevron-dark reviews-chevron" src="../../static/images/common-icons/right-arrow-white.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  
  export default {
    props: ['component', 'images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
        activeClass: 'active'
      };
    },
    computed: {
      ...mapGetters(["chosenArray"]),
    },
    mounted() {
      (function() {
        
        var c = {
          init: function() {
            $('#compliantBannerCarousel').carousel({
              interval: 5000
              })
          }
        }
        $(document).ready(c.init);
      })(jQuery);
    }
  };
  </script>

<style scoped src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"></style>

<style scoped>
  .compliant-banners {
    background: #ffff;
    padding-top: 4%;
    padding-bottom: 4%;
  }
  .compliant-banners .carousel-indicators {
    bottom: 10px;
    margin-bottom: 0px;
  }
  .compliant-banners .carousel-indicators li {
    background: rgba(255,255,255,0);
    height: 14px;
    width: 14px;
    border-radius: 100%;
    padding: 3px;
    margin: 1px 5px 1px 1px;
    border: none;
  }
  .compliant-banners .carousel-indicators li .inner-circle {
    background: rgba(255,255,255,.8);
    height: 8px;
    width: 8px;
    border-radius: 100%;
  }
  .compliant-banners .carousel-indicators .active {
    background: rgba(255,255,255,0);
    border: 2px solid rgba(255,255,255,1);
  }
  .compliant-banners .carousel-indicators .active .inner-circle {
    background: rgba(255,255,255,0);
  }
  .compliant-banners .carousel-control.left,
  .compliant-banners .carousel-control.right {
    background-image: none;
    width: 30px;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  .compliant-banners .carousel-control img {
    position: absolute;
    top: calc(50% - 11px);
    z-index: 105;
    display: inline-block;
    height: 22px;
  }
  .compliant-banners .carousel-control.left img {
    left: 30px;
  }
  .compliant-banners .carousel-control.right img {
    right: 30px;
  }

  @media (min-width: 1462px) {
    .compliant-banners .banner-container {
      width: 1422px;
      max-width: 1422px;
      padding: 0px;
    }
  }

  @media (max-width: 991px) {
    .compliant-banners .carousel-control.left img {
      left: 15px;
    }
    .compliant-banners .carousel-control.right img {
      right: 15px;
    }
  }

  @media (max-width: 767px) {
    .compliant-banners .banner-container {
      width: 100%;
      padding: 0px;
    }
  }
</style>